module.exports = {"MQ_SMALL":"640px","MQ_MEDIUM":"768px","MQ_LARGE":"1024px","MQ_XLARGE":"1280px","MQ_XXLARGE":"1536px","MQ_HUGE":"1920px"};